import WEBSITE_BOOKING_STATUS_QUERY from "./website-booking-status.query";
import { WebUserStatus } from "./website-booking-status.interface";
import { useLazyQuery } from "@apollo/client";

const useWebsiteBookingStatus = () => {
  const [getUserStatus, { data, loading, error }] = useLazyQuery<WebUserStatus>(WEBSITE_BOOKING_STATUS_QUERY);

  const getWebUserStatus = () => {
    getUserStatus({
      fetchPolicy: "cache-and-network",
    });
  };

  return {
    data: data?.webUserStatus,
    loading,
    error,
    getWebUserStatus,
  };
};

export default useWebsiteBookingStatus;

